import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { MobileOutlined, QrcodeOutlined } from '@ant-design/icons';

export default function MobileWebAppPromoModal({ isOpen, onDismiss }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dialogRef = useRef(null);

  if (!isOpen) return null;

  const handleOverlayClick = (event) => {
    if (dialogRef.current && !dialogRef.current.contains(event.target)) {
      onDismiss();
    }
  };

  const handleConnect = () => {
    onDismiss();
    navigate('/settings/security#mobile-login', {
      state: { scrollToMobileLogin: true },
    });
  };

  return (
    <div
      className="mobile-webapp-promo"
      role="presentation"
      onClick={handleOverlayClick}
      data-resource="private.settings.security"
      data-action="read"
    >
      <div
        ref={dialogRef}
        className="mobile-webapp-promo__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mobile-webapp-promo-title"
      >
        <button
          type="button"
          className="mobile-webapp-promo__close"
          onClick={onDismiss}
          aria-label={t('mobileWebAppPromoDismiss')}
        >
          ×
        </button>

        <div className="mobile-webapp-promo__icon-wrap" aria-hidden>
          <MobileOutlined className="mobile-webapp-promo__icon mobile-webapp-promo__icon--phone" />
          <QrcodeOutlined className="mobile-webapp-promo__icon mobile-webapp-promo__icon--qr" />
        </div>

        <h3 id="mobile-webapp-promo-title" className="mobile-webapp-promo__title">
          {t('mobileWebAppPromoTitle')}
        </h3>

        <p className="mobile-webapp-promo__message">
          {t('mobileWebAppPromoMessage')}
        </p>

        <div className="mobile-webapp-promo__actions">
          <button
            type="button"
            className="btn-style1 mobile-webapp-promo__cta"
            onClick={handleConnect}
            data-resource="private.settings.security"
            data-action="read"
          >
            {t('mobileWebAppPromoCta')}
          </button>

          <button
            type="button"
            className="btn-style2 mobile-webapp-promo__dismiss"
            onClick={onDismiss}
            data-resource="private.settings.security"
            data-action="read"
          >
            {t('mobileWebAppPromoDismiss')}
          </button>
        </div>
      </div>
    </div>
  );
}
